import gql from "graphql-tag";

export const MY_TAX_REMOVE_DECLARATION_REQUEST = gql`
  mutation removeTaxDeclarationRequest(
    $year: String!
    $taxDeclarationType: String!
  ) {
    removeTaxDeclarationRequest(
      year: $year
      taxDeclarationType: $taxDeclarationType
    ) {
      result
      messages
    }
  }
`;
